import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching all community groups
 */
export const GET_COMMUNITY_GROUPS = gql`
  query GetCommunityGroups {
    communityGroups {
      id
      name
      description
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
      }
      actions {
        name
        description
        deliveryType
        labels {
          labelId
          severity
        }
        policies
        operatorName
        deliverySettings {
          url
          postPayload
        }
      }
      workflowConfigurations {
        type
        topicActions {
          topicName
          actionNames
        }
      }
      securityGroups {
        admin
        moderator
        user
      }
      userRole
      roles
    }
  }
`;
